module.exports = __webpack_public_path__ + "media/images/logo_black-a676ed39.svg";